import { __assign, __awaiter, __extends, __generator } from "tslib";
/* eslint-disable no-param-reassign */
var TimeoutError = /** @class */ (function (_super) {
    __extends(TimeoutError, _super);
    function TimeoutError(message) {
        var _this = _super.call(this, message) || this;
        _this.name = 'TimeoutError';
        return _this;
    }
    return TimeoutError;
}(Error));
export { TimeoutError };
export default function pTimeout(promise, milliseconds, fallback, options) {
    var _this = this;
    var timer;
    var cancelablePromise = new Promise(function (resolve, reject) {
        if (typeof milliseconds !== 'number' || Math.sign(milliseconds) !== 1) {
            throw new TypeError("Expected `milliseconds` to be a positive number, got `" + milliseconds + "`");
        }
        if (milliseconds === Number.POSITIVE_INFINITY) {
            resolve(promise);
            return;
        }
        options = __assign({ customTimers: { setTimeout: setTimeout, clearTimeout: clearTimeout } }, options);
        timer = options.customTimers.setTimeout.call(undefined, function () {
            if (typeof fallback === 'function') {
                try {
                    resolve(fallback());
                }
                catch (error) {
                    reject(error);
                }
                return;
            }
            var message = typeof fallback === 'string' ? fallback : "Promise timed out after " + milliseconds + " milliseconds";
            var timeoutError = fallback instanceof Error ? fallback : new TimeoutError(message);
            if (typeof promise.cancel === 'function') {
                promise.cancel();
            }
            reject(timeoutError);
        }, milliseconds);
        (function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, 3, 4]);
                        _a = resolve;
                        return [4 /*yield*/, promise];
                    case 1:
                        _a.apply(void 0, [_b.sent()]);
                        return [3 /*break*/, 4];
                    case 2:
                        error_1 = _b.sent();
                        reject(error_1);
                        return [3 /*break*/, 4];
                    case 3:
                        options.customTimers.clearTimeout.call(undefined, timer);
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); })();
    });
    cancelablePromise.clear = function () {
        clearTimeout(timer);
        timer = undefined;
    };
    return cancelablePromise;
}
//# sourceMappingURL=index.js.map